import React from 'react';
import PropTypes from 'prop-types';

function Social({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M12 17a2 2 0 100-4 2 2 0 000 4zM12 17c-.794.008-1.553.371-2.114 1.012-.561.642-.88 1.51-.886 2.417V21h6v-.571c-.007-.907-.325-1.775-.886-2.416-.561-.642-1.32-1.006-2.114-1.013zM19 6a2 2 0 100-4 2 2 0 000 4zM22 10c0-2.5-1.35-4-3-4s-3 1.5-3 4h6zM5 6a2 2 0 100-4 2 2 0 000 4zM8 10c0-2.5-1.35-4-3-4s-3 1.5-3 4h6zM9.2 6h5.6-5.6zM5 12.429L7.8 15 5 12.429zm14 0L16.2 15l2.8-2.571z"
      />
    </svg>
  );
}

Social.propTypes = {
  stroke: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Social;
